import React from "react";
import "../ui/ui.scss";

/**
 * InfoCard — A generic card wrapper with optional header (icon + title + action) and body.
 *
 * Props:
 *   icon       — React node for header icon
 *   iconClass  — Color class: blue | violet | emerald | rose | amber | cyan | primary
 *   title      — Card title string
 *   subtitle   — Card subtitle string
 *   action     — React node rendered on the right of header (button, link, badge)
 *   footer     — React node for footer area
 *   className  — Extra class on outer card
 *   children   — Card body content
 *   onClick    — Click handler on the card
 *   hover      — Enable hover elevation
 */
const InfoCard = ({
  icon,
  iconClass,
  title,
  subtitle,
  action,
  footer,
  className = "",
  children,
  onClick,
  hover = false,
}) => (
  <div
    className={`ui-card ${hover ? "ui-card--hover" : ""} ${className}`}
    onClick={onClick}
    role={onClick ? "button" : undefined}
    tabIndex={onClick ? 0 : undefined}
  >
    {(title || action) && (
      <div className="ui-card__header">
        <div className="ui-card__header-left">
          {icon && (
            <div className={`ui-card__header-icon ${iconClass || ""}`}>
              {icon}
            </div>
          )}
          {title && (
            <div>
              <div className="ui-card__title">{title}</div>
              {subtitle && <div className="ui-card__subtitle">{subtitle}</div>}
            </div>
          )}
        </div>
        {action && <div>{action}</div>}
      </div>
    )}
    {children && <div className="ui-card__body">{children}</div>}
    {footer && <div className="ui-card__footer">{footer}</div>}
  </div>
);

export default InfoCard;
